import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useTRPC } from "@/trpc/client";

export const useCreateStudyset = () => {
  const queryClient = useQueryClient();
  const trpc = useTRPC();
  return useMutation(
    trpc.studysets.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: trpc.studysets.get.queryKey(),
        });
        toast.success("Study Set created successfully");
      },
      onError: (error) => {
        console.error("Failed to create Study Set", error);
        toast.error(error.message);
      },
    }),
  );
};
